import { FC, useMemo } from 'react'
import { MarketingMaterialsContextProvider, VisualsMarketingContextProvider } from 'components/pages/VisualsMarketing/_main/contexts'

import { AnalyticsEvent } from 'utils/analytics'
import Box from '@mui/material/Box'
import { ClientPropertyAITextGenerator } from '../../ClientPropertyAITextGenerator'
import { EmptyContent } from 'components/common/EmptyContent'
import { GRAY_800 } from 'constants/styling/theme'
import { MUIButton } from 'components/common/MUIButton'
import { PageTransition } from 'utils/animations'
import { Path } from 'constants/router'
import { RealEstatePropertyAssignmentDTO } from 'models/property'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import { VisualsMarketingFormProvider } from 'components/pages/VisualsMarketing/_main/contexts/VisualsMarketing.form'
import { useCanUserOrder } from 'utils/user/canUserOrder'
import { useClientProperty } from '../contexts'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useUserData } from 'components/contexts/UserDataContext'
import { useWorkspacePlan } from 'utils/hooks'

export const ClientPropertyAITextGeneratorPage: FC = () => {
  const { hasWorkspaceActiveSubscription } = useWorkspacePlan()
  const { isWorkspaceResolved } = useUserData()
  const { propertyData, propertyFullAddress } = useClientProperty()

  // Wait for workspace resolution before gating, otherwise the content briefly disappears
  // for a subscribed user on hard refresh while currentUserWorkspace is still null.
  if (!isWorkspaceResolved) return null

  // No content if the selected workspace doesn't have an active subscription
  if (!hasWorkspaceActiveSubscription || !propertyData?.id) return null

  return (
    <PageTransition>

      <VisualsMarketingFormProvider realtyId={propertyData.id} address={propertyFullAddress}>
        <MarketingMaterialsContextProvider realtyId={propertyData.id}>
          <VisualsMarketingContextProvider>

            <ClientPropertyAITextGenerator />

          </VisualsMarketingContextProvider>
        </MarketingMaterialsContextProvider>
      </VisualsMarketingFormProvider>

    </PageTransition>
  )
}
